module.exports = __webpack_public_path__ + "img/profile.40141c59.svg";